<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  banks: { type: Array, default: () => [] },
  pixKeys: { type: Array, default: () => [] },
  draft: { type: Object, required: true },
  bankPayment: { type: Boolean, default: false },
  pixDocumentError: { type: String, default: '' },
});

const emit = defineEmits([
  'select-bank',
  'select-pix-key',
  'update-field',
  'update-pix-key',
]);
const { t } = useI18n();
</script>

<template>
  <template v-if="bankPayment">
    <LaisField
      :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.PAYMENT.BANK')"
      required
    >
      <select
        :value="draft.banco_id"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
        @change="emit('select-bank', $event)"
      >
        <option value="">
          {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.FIELDS.SELECT') }}
        </option>
        <option v-for="bank in banks" :key="bank.id" :value="bank.id">
          {{ bank.nome || bank.name }}
        </option>
      </select>
    </LaisField>
    <div class="grid gap-4 sm:grid-cols-2">
      <LaisField
        :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.PAYMENT.AGENCY')"
        required
      >
        <input
          :value="draft.agencia"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          @input="emit('update-field', 'agencia', $event.target.value)"
        />
      </LaisField>
      <LaisField
        :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.PAYMENT.ACCOUNT')"
        required
      >
        <input
          :value="draft.numero_conta"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          @input="emit('update-field', 'numero_conta', $event.target.value)"
        />
      </LaisField>
    </div>
  </template>
  <template v-else>
    <LaisField
      :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.PAYMENT.PIX_KEY_TYPE')"
      required
    >
      <select
        :value="draft.tipo_chave_pix_id"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
        @change="emit('select-pix-key', $event)"
      >
        <option value="">
          {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.FIELDS.SELECT') }}
        </option>
        <option v-for="key in pixKeys" :key="key.id" :value="key.id">
          {{ key.name }}
        </option>
      </select>
    </LaisField>
    <LaisField
      :label="t('REAL_ESTATE_COMMISSION_INSTALLMENT.PAYMENT.PIX_KEY')"
      required
    >
      <input
        :value="draft.chave_pix"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
        @input="emit('update-pix-key', $event)"
      />
    </LaisField>
    <p v-if="pixDocumentError" class="text-sm text-red-700" role="alert">
      {{ pixDocumentError }}
    </p>
  </template>
</template>
